import { get, set, del } from 'idb-keyval'
import {
    PersistedClient,
    Persister,
} from '@tanstack/react-query-persist-client'

export function createIDBPersister(idbValidKey: IDBValidKey = 'reactQuery') {
    return {
        persistClient: async (client: PersistedClient) => {
            // Deduplicate mutations by mutationKey
            const mutationMap = new Map();
            for (const mutation of client.clientState.mutations) {
                const key = JSON.stringify(mutation.mutationKey);
                mutationMap.set(key, mutation);
            }
            const dedupedMutations = Array.from(mutationMap.values());
            const newClient = { ...client, clientState: { ...client.clientState, mutations: dedupedMutations } };

            await set(idbValidKey, newClient)
        },
        restoreClient: async () => {
            return await get<PersistedClient>(idbValidKey)
        },
        removeClient: async () => {
            await del(idbValidKey)
        },
    } as Persister
}